// modifyHeaderSecondary.js — bjxy 扩展 HeaderSecondary 注入"预约体验"按钮 (辉哥 2026-09-07 11:00 反馈)
//   现象: bjxy.top 桌面端顶部只有"发布主题"按钮 (ziven-theme-aura 注入的 .ziven-aura-new-discussion), 走 vendor DiscussionComposer
//     实际 bjxy 业务是预约体验, "发布主题"对用户没意义 (bjxy 不是发讨论场景)
//     mobile 端有"预约体验"按钮 (.IndexPage-newDiscussion 走 bjxy 自定义 BookingModal), 但 desktop 没有
//   修法: bjxy 扩展走 vendor HeaderSecondary extend, 在 ziven-aura-new-discussion (priority 50) 之前 priority 51 注入 bjxy-new-booking 按钮
//     - 文字: 走 bjxy_hero_cta_text setting (跟 hero CTA 一致) + fallback "预约体验"
//     - icon: fas fa-calendar-plus (跟 mobile IndexPage-newDiscussion 一致, 跟"发布主题"的 fa-edit 区分)
//     - onclick: app.modal.show(BookingModal) (跟 mobile IndexPage-newDiscussion 一致)
//     - className: Button Button--primary ziven-bjxy-new-booking (新 class, 跟 .ziven-aura-new-discussion 区分)
//     - 视觉: 跟 .ziven-aura-new-discussion 同款 (蓝底白字方角 4px 92x34), 颜色 #2D7BE5 鲜艳蓝 (c.f.m.e 改的)
//   优先级设计:
//     - ziven-aura-new-discussion priority 50
//     - bjxy-new-booking priority 51 (数字**大于** 50 ⇒ 排在 aura 前面 = 靠左, 跟辉哥 9/7 11:00 拍板"加在发布主题按钮左侧"一致)
//     - 为什么 51 在左边: vendor ItemList.toArray() 按 priority **降序**排
//       (ItemList.ts:212 `items.sort((a, b) => b.priority - a.priority)`, 其文档也写明
//        "Items with a higher priority will be positioned before items with a lower priority")
//       ⇒ 51 > 50 ⇒ bjxy-new-booking 排在数组前面; ul.Header-controls 按 DOM 顺序左→右渲染
//       ⇒ 实测 DOM 顺序 li.item-ziven-bjxy-new-booking 在 li.item-ziven-aura-new-discussion 之前 (= 视觉在"发布主题"左侧)
//   实战教训: 任何 ziven 扩展要 desktop 顶栏加 button, 走 vendor HeaderSecondary.items extend
//     - 不要直接修改 ziven-theme-aura 注入的按钮 (侵入主题), 自己 extend 加新 button
//     - 跟 ziven-theme-aura 优先级错开 1 (51 vs 50) 保证位置在左侧
//       (注意是**加 1 不是减 1**: ItemList 降序排, 数字越大越靠左)
//     - onclick 必须用 BookingModal (跟 mobile IndexPage-newDiscussion 一致), 不要走 vendor DiscussionComposer (发讨论不是 bjxy 业务)
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import BookingModal from './components/BookingModal';
export default function modifyHeaderSecondary() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    // priority 51 = 在 ziven-aura-new-discussion (50) 之前, 桌面端"发布主题"按钮左侧
    //   (ItemList 按 priority 降序排: 51 > 50 ⇒ 排前面 = 靠左, vendor ItemList.ts:212)
    items.add('ziven-bjxy-new-booking', m(Button, {
      icon: "fas fa-calendar-plus",
      className: "Button Button--primary ziven-bjxy-new-booking",
      itemClassName: "App-primaryControl",
      "aria-label": app.forum.attribute('bjxy_hero_cta_text') || '预约体验',
      onclick: () => {
        // 跟 mobile IndexPage-newDiscussion.onclick 一致, 弹 BookingModal (bjxy 业务)
        // 区别于 ziven-aura-new-discussion.onclick 弹 vendor DiscussionComposer (发新讨论)
        app.modal.show(BookingModal);
      }
    }, app.forum.attribute('bjxy_hero_cta_text') || '预约体验'), 51);
  });
}